import React from 'react'
import {A, Box, Email, Item, Span} from 'react-html-email-browser'

export default (entrepriseName, dateTime) => (
    <Email title="Convocation - MonEntretienPRO">
        <Item>
            <Span fontSize={15}>MonEntretienPRO</Span>
        </Item>
        <Item>
            <Box cellSpacing={20} width="100%" style={{borderTop: '3px solid black'}}>
                <Item>
                    <Span color={'black'}>
                        Bonjour,<br/>
                        Vous êtes convoqué(e) par votre entreprise [ {entrepriseName} ] pour un entretien professionnel
                        à la date suivante : <br/><br/>
                        <Box style={{textAlign: 'center', width: '100%'}}>
                            <Span color={'red'}>{dateTime}</Span>
                        </Box><br/><br/>
                        Veuillez vous connecter sur votre espace personnel en utilisant votre adresse email actuelle
                        afin de remplir les formulaires de préparation.<br/><br/>
                        PS: Pour récupérer votre mot de passe, Veuillez cliquer <A
                        href='https://monentretienpro.fr/recup_mot_de_passe'>ici.</A><br/>
                        Cordialement,
                    </Span><br/><br/>
                    <A href='https://monentretienpro.fr'>MonEntretienPRO.fr</A>
                </Item>
            </Box>
        </Item>
    </Email>
);


// WEBPACK FOOTER //
// ./src/components/shared/utils/ConvocationEmailComponent.js